export const PACKAGE_NAME = 'agenticPlanning';
export const TEAM_NAME = 'Gravity-AI';
